import React, { useContext } from "react";
import { observer } from "mobx-react";
import classNames from "classnames";
import { EventContext } from "@gp/components";
import { TTip } from "@data-types/offer/event-row/EventRow";
import { useOfferContext } from "../../../../../../../../state/hooks/offer/useOfferContext";
import { TipIndicatorButtonHoc } from "./TipIndicatorButtonHoc";

export const PlayerTipButton = observer(function PlayerTipButton(props: {
	tip: TTip["tip"];
	isStats?: boolean;
	isTitle?: boolean;
}) {
	//#region hooks

	const store = useOfferContext();

	const event = useContext(EventContext);

	//#endregion hooks

	const eventKeys = store.eventKeysMap.get(event.id);
	const key = eventKeys?.get(props.tip?.keyId || "");

	const wrapperClasses = classNames({
		"offer--player__item quote quote--special": !props.isStats,
		"card--players__heading": props.isStats,
	});

	const marginClasses = classNames({
		"offer--player__margin quote--special__tip quote quote--margin":
			!props.isStats,
		"card--players__title": props.isStats,
	});

	const tipClasses = classNames({
		"quote--special__odd quote quote--button": !props.isStats,
		"card--players__quota quota": props.isStats,
	});

	return (
		<div className={wrapperClasses}>
			<div className={marginClasses} title={props.tip?.displayTip}>
				{props.tip?.displayTip}
			</div>
			<TipIndicatorButtonHoc
				eventKeyOffer={key}
				tip={props.tip}
				buttonClasses={tipClasses}
			/>
		</div>
	);
});
